export default __webpack_public_path__ + "static/media/rachel-bottom.619b7e33.png";